import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiFormControl from '@mui/material/FormControl';
import MuiFormHelperText from '@mui/material/FormHelperText';
import MuiFormLabel from '@mui/material/FormLabel';
import MuiRadioGroup from '@mui/material/RadioGroup';
import * as React from 'react';
import { styled } from '../styled';
import { firstLetterUppercase, sentence, Typography } from '../typography';
import { withVersion } from '../utils';
import { RadioGroupContext } from './context';
const StyledRadioGroup = styled(MuiRadioGroup)(({ theme }) => ({
    gap: 0,
    '&.MuiFormGroup-row': {
        columnGap: theme.spacing(3),
        rowGap: 0
    },
    '& .MuiFormControlLabel-root': {
        margin: 0
    }
}));
const RadioGroupImpl = (props) => {
    const { label, helperText, error, row, value, defaultValue, name, onChange, children, className, 'data-role': dataRole, 'data-role-value': dataRoleValue } = props;
    return (_jsx(RadioGroupContext.Provider, { value: true, children: _jsxs(MuiFormControl, { component: "fieldset", className: className, error: !!error, "data-role": dataRole, "data-role-value": dataRoleValue, children: [label && (_jsx(MuiFormLabel, { component: "legend", children: _jsx(Typography, { textTransform: "sentence", children: label }) })), _jsx(StyledRadioGroup, { row: row, value: value, defaultValue: defaultValue, name: name, onChange: (e) => onChange?.(e.target.value, e), children: children }), error ? (_jsx(MuiFormHelperText, { children: sentence(error) })) : (helperText && (_jsx(MuiFormHelperText, { sx: { ...firstLetterUppercase }, children: helperText })))] }) }));
};
export const RadioGroup = withVersion(RadioGroupImpl, '1.0.0');
